<template>
    <div class="border rounded border-grayxlight px-2 pt-1 min-w-20">
        <div class="text-gray text-[10px]">{{ label }}</div>
        <div class="text-base text-darkblue semibold">{{ value }}</div>
    </div>
</template>

<script setup lang="ts">
interface Props {
    label: string,
    value: string | number
}

defineProps<Props>()

</script>
